var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-block block-link-input"},[_c('a',{staticClass:"block-link-input__link",attrs:{"href":("/recommend/lp/" + _vm.lpId + "/basic/input")},on:{"click":function($event){$event.preventDefault();return _vm.onBasicFortuneLickClick($event)}}},[_vm._v("他の誕生日で占う")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f395f680","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/counselor/houen/blocks/BlockLinkInput.vue
// module id = null
// module chunks = 